import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import store from '@/store'

export const usePublicationsStore = defineStore('publications', {
  state: () => ({
    publications: [],
    fetchInitiated: false,
  }),

  getters: {
    allAsObject() {
      const entries = this.publications.map((pub) => {
        return [pub.name, pub.id]
      })

      return Object.fromEntries(entries)
    },

    hasMultiple() {
      return this.publications.length > 1
    },

    hasOne() {
      return this.publications.length === 1
    },

    // Returns the signular publication ID, when there is only one
    oneId() {
      if (!this.hasOne) return null

      this.publications[0]?.id
    },

    getForId() {
      return (id) => this.publications.find((pub) => pub.id === id)
    }
  },

  actions: {
    async fetch() {
      this.fetchInitiated = true

      try {
        const response = await httpClient.get('/api/internal/publications')
        this.publications = response.data.publications
      } catch (err) {
        console.error('Error fetching publications:', err)
        if (store && store.dispatch) {
          store.dispatch('messages/addError', err, { root: true })
        } else {
          console.error("Legacy Vuex store not available for error reporting.")
        }
        throw err
      }
    },

    async fetchOnce() {
      if (this.fetchInitiated) {
        return Promise.resolve()
      }

      return this.fetch()
    },

    async destroy({ publicationId }) {
      await httpClient.delete(`/api/internal/publications/${publicationId}`).then(() => {
        store.dispatch('messages/addNotice', 'Publication deleted')
        this.publications = this.publications.filter((pub) => pub.id !== publicationId)
      }).catch(err => {
        console.error(err)
        store.dispatch('messages/addError', err)
      })
    }
  },
})
